<template>
  <v-app-bar app elevation="0" :color="barcolor" dark>

    <div class="d-flex align-center">
      <h1 class="hidden-sm-and-down">Maayaas Stay</h1>
    </div>

    <v-spacer></v-spacer>

    <v-btn v-for="icon in icons" :key="icon"
      :href="icon['url']"
      target="_blank" icon large class="mx-2"
      >
      <v-icon>{{ icon["name"] }}</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'TitleBar',

  data: () => ({
    barcolor: "secondary",
    icons: [
      {
        name: "mdi-email",
        url: "mailto:contact@maayaas.com",
      },
      {
        name: "fab fa-facebook",
        url: "http://www.facebook.com/MaayaasStay",
      },
      {
        name: "mdi-directions",
        url: "https://goo.gl/maps/pnpLJKyhejwoFXHX7",
      },
      {
        name: "mdi-phone",
        url: "tel:+919521900500",
      },
    ],
  }),
};
</script>
